export type SECTOR_KEY = 'index' | 'internet' | 'manufactor' | 'finance' | 'bio' | 'battery' | 'steel' | 'cars' | 'energy' | 'construction' | 'game' | 'retail';

export const titleBySector: Record<string, string> = {
  index: '지수',
  internet: '인터넷',
  manufactor: '제조업',
  cars: '자동차',
  finance: '금융',
  bio: '바이오',
  battery: '배터리',
  steel: '철강',
  construction: '건설',
  energy: '에너지',
  game: '게임',
  retail: '소비재',
};

export const symbolsBySector: Record<string, string[]> = {
  // index: [/*'KOSPI', 'KOSDAQ'*/],
  internet: ['035420', '035720'],
  manufactor: ['005930', '000660', '066570'],
  cars: ['005380', '000270', '012330'],
  finance: ['323410', '055550', '105560', '377300', '086790', '032830'],
  bio: ['207940', '068270', '302440'],
  energy: ['096770','051910', '006400', '373220'],
  game: ['259960', '036570'],
  retail: ['051900'],
  steel: ['005490'],
  construction: ['028260'],
};
